import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DVQuiz } from './DVQuiz';

const container: HTMLElement | null = document.getElementById('dvquiz');

if (container !== null) {

    const quizId: string = container.getAttribute('data-quiz_id') as string;

    if(quizId){
        ReactDOM.render(<DVQuiz quizId={quizId} />,container);
    }
}

